import React, { useRef, useState, useEffect } from 'react'
import { Dropdown } from 'react-bootstrap'

import './dropdown-main.styles.scss';

import DropdownArrow from '../../assets/icons/Icon - Arrow - Down.svg';
import CheckmarkIcon from '../../assets/icons/Icon - Checkmark.svg';
import DisabledDropdownArrow from '../../assets/icons/Icon - Arrow - Disabled.svg'

// values MUST be an array in the format {id: ..., name: ..., }
//   id is the 'unique' property of each item, and name is the displayed value
//   disabled is an optional field that just greys out the option's text, and disallows the user from selecting it
const DropdownMain = ({ values, dropdownButtonText, onSelect, currentSelected, disabled, projectOwner, additonalClasses = "", alignRight = false }) => {

    // are there >= 6 total items?
    const [isScroll, setIsScroll] = useState(false);

    // workaround to display up arrow icon when dropdown toggled, and down arrow otherwise
    const [toggled, setToggled] = useState(false);
    const [toggled1, setToggled1] = useState(false);
    const node = useRef();

    useEffect(() => {
        setIsScroll(values && values.length >= 6)
        document.addEventListener("click", handleClick);
        return () => {
            document.removeEventListener("click", handleClick);
        };

    }, [])

    const handleClick = (e) => {
        if (node.current && node.current.contains(e.target)) {
            setToggled(!toggled);
            return;
        }
        setToggled1(false);
    }

    // when new item is selected from dropdown
    const handleChange = (value) => {
        onSelect(value);
    }

    // determine if value should be displayed or not
    const isDisplayValue = (value) => {
        if (!currentSelected) return true;
        return currentSelected.id !== value.id;
    }

    // determine if selected value should be displayed in position or not
    // show if: item selected and less than 6 total items in the list
    const isDisplaySelected = (value) => {
        return currentSelected && currentSelected.id === value.id && !isScroll;
    }

    const onKeyDownDropdownItem = (keyEvent, values) => {
        if ((keyEvent.charCode || keyEvent.keyCode) === 13) {
            handleChange(values);
            setToggled(false);
            setToggled1(false);
        }
    }

    const onKeyDropDownToggle = (keyEvent) => {
        if ((keyEvent.charCode || keyEvent.keyCode) === 40) {
            setToggled1(true);
        }

    }

    const cutString = (str) => {
        if(str == null){
            str = values.map((value) => {
                if(value.id == currentSelected.id){
                    return value.name;
                }
            })
        }
        if ( projectOwner && str.length > 32){
            str = str.substring(0,31);
            str = str + "...";
        }
        return str;
    }

    const displaySelected = () => {
        if(currentSelected.name == null){
            currentSelected.name = values.map((value) => {
                if(value.id == currentSelected.id){
                    return value.name;
                }
            })
        }
        return (
            <>
                <Dropdown.Item onKeyDown={(keyEvent) => onKeyDownDropdownItem(keyEvent, currentSelected)} className='dropdown-row dropdown-selected-row' key={currentSelected.id} value={currentSelected.id} onClick={() => { handleChange(currentSelected) }}>
                    <span className='dropdown-row-text'>
                        {currentSelected.name}
                    </span>
                    <img alt="checkmark" src={CheckmarkIcon} className="dropdown-selected-row-checkmark" />
                </Dropdown.Item>
                <Dropdown.Divider className='dropdown-row-divider' />
            </>
        )
    }

    // styling for a disabled dropdown
    if (disabled) {
        if(currentSelected && currentSelected.name == null){
            currentSelected.name = values.map((value) => {
                if(value.id == currentSelected.id){
                    return value.name;
                }
            })
        }
        return (
            <div className="dropdown-main-disabled">
                <Dropdown className={`dropdown-main`}>
                    <Dropdown.Toggle id='dropdown-toggle-disabled' className={'dropdown-button dropdown-button-disabled'} as='div' onClick={() => { }}>
                        {currentSelected ?
                            <span className='dropdown-button-selected-text'> {currentSelected.name}</span>
                            :
                            <span className='dropdown-button-text'> {dropdownButtonText || "Select an item"} </span>
                        }

                        <img className='dropdown-arrow dropdown-arrow-disabled' alt='dropdown-arrow' src={DisabledDropdownArrow} />

                    </Dropdown.Toggle>
                </Dropdown>
            </div>
        )
    }

    // toggled && toggled1 is true when the dropdown toggle is active, and false otherwise
    return (
        <div className="dropdown-main-top-level" ref={node} onClick={(e) => handleClick(e)}>
            <Dropdown show={toggled1} className={`dropdown-main`} onClick={() => { setToggled1(!toggled1) }}>
                <Dropdown.Toggle onKeyDown={onKeyDropDownToggle} tabIndex="0" id='dropdown-toggle' className={toggled && toggled1 ? 'dropdown-button selected-button' : 'dropdown-button'} as='div' >
                    {currentSelected ?
                        <span className='dropdown-button-selected-text'> {cutString(currentSelected.name)} </span>
                        :
                        <span className='dropdown-button-text'> {dropdownButtonText || "Select an item"} </span>
                    }

                    <img className={`dropdown-arrow${toggled && toggled1 ? "-up" : ""}`} alt='dropdown-arrow' src={DropdownArrow} />
                </Dropdown.Toggle>

                <Dropdown.Menu className={`${additonalClasses} dropdown-main-menu ${isScroll ? "" : "no-scroll"}`} as='div' alignRight={alignRight}>
                    {/* Selected item always remains at top with checkmark next to its value */}
                    {currentSelected && isScroll && displaySelected()}
                    {values && values.length > 0 &&
                        values.map((value, index) => {
                            return (
                                <React.Fragment key={index}>
                                    {isDisplaySelected(value) && displaySelected()}

                                    {/* don't display the item if it's already selected */}
                                    {isDisplayValue(value) &&
                                        <>
                                            <Dropdown.Item onKeyDown={(keyEvent) => onKeyDownDropdownItem(keyEvent, value)} className={`dropdown-row`} key={value.id} value={value.id} disabled={value.disabled} onClick={() => { handleChange(value) }}>
                                                <span className={value.disabled ? 'dropdown-row-text dropdown-disabled-text' : 'dropdown-row-text'}>
                                                    {value.name}
                                                </span>
                                            </Dropdown.Item>

                                            {(index !== values.length - 1) && <Dropdown.Divider className={`dropdown-row-divider`} />}
                                        </>
                                    }
                                </React.Fragment>
                            )
                        })
                    }
                </Dropdown.Menu>
            </Dropdown>
        </div>
    )
}

export default DropdownMain;
